import React from 'react'
import { NORESULT } from '../../configuration'
export default function Noresult () {
  return (
    <div className='subtitle-color montserratregular' tabIndex={0} aria-label={NORESULT}>{NORESULT}</div>
  )
}
